const width = {
  FULL: 1440,
  SEMI: 1280,
};

export default width;
